export default __webpack_public_path__ + "static/media/card1.562d0007.svg";